import { render } from "./TrackingTagsList.vue?vue&type=template&id=381b6d5c&scoped=true"
import script from "./TrackingTagsList.vue?vue&type=script&lang=js"
export * from "./TrackingTagsList.vue?vue&type=script&lang=js"

import "./TrackingTagsList.vue?vue&type=style&index=0&id=381b6d5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-381b6d5c"]])

export default __exports__